// extracted by mini-css-extract-plugin
module.exports = {"pillContainer":"SelectedFilters_pillContainer__oxkiH","clearFilters":"SelectedFilters_clearFilters__1ygi3"};